
























import { Component, Vue } from "vue-property-decorator";
import CModal from "@/basics/modal/CModal.vue";
import CButton from "@/basics/buttons/CButton.vue";
import ModalTitle from "@/basics/modal/ModalTitle.vue";
import { remoteClose } from "@/graphql/mutation/remoteClose";

@Component({
  components: { CModal, CButton, ModalTitle }
})
export default class EditModal extends Vue {
  loading = false;

  async send() {
    // ロード状態にする
    this.loading = true;

    try {
      // コマンド送信
      const roomId = this.$route.params.roomId as string;
      await remoteClose(this.$apollo, roomId);

      // 送信に成功したら遷移
      alert("施錠しました。");
      this.close();
    } catch (e) {
      console.error(e);
      alert("施錠に失敗しました。" + e.message);
    } finally {
      // 処理終了
      this.loading = false;
    }
  }

  close() {
    this.$router.push({ name: "room-remote" });
  }
}
